export default __webpack_public_path__ + "static/media/all-directions.14befbee.svg";